module.exports = __webpack_public_path__ + "img/sec5555.35b50be5.jpg";